import axios from "axios";

const prodBaseUrl = "https://api.davidsimak.dev/formula-solver-api/solve"

export default axios.create({
  baseURL: prodBaseUrl,
  withCredentials: false
});
